export default __webpack_public_path__ + "static/media/minting_board.d60e3cd7.webp";